import React from 'react'

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import HeaderIcon from '@material-ui/icons/NearMe'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as Model from 'api/model'
import PoziDrawer from 'drawer/drawer'
import AccordionWrapper from 'drawer/tabs/AccordionWrapper'
import PoziPropertyLookup from 'drawer/tabs/info/property-lookup'
import PoziDrawerTabToolsBuffer from 'drawer/tabs/tools/buffer'
import PoziSelect from 'drawer/tabs/tools/select'
import CoordinateSelectTool from 'drawer/tabs/tools/select/CoordinateSelectTool'
import Upgrade from 'drawer/tabs/Upgrade'
import selectPropertyFromCsvImg from 'img/tools/home.svg'
import selectBufferImg from 'img/tools/select-buffer.svg'
import lineSelectImg from 'img/tools/select-line-noun-graph-1190709.svg'
import regionSelectImg from 'img/tools/select-region-noun-237368.svg'

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    paddingLeft: 26,
    paddingBottom: 10,
    rowGap: 10
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
    width: 24
  },
  columnGroup: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginTop: 16,
    marginBottom: 16,
    rowGap: 10
  },
  hiddenElement: {
    display: 'none'
  },
  rowGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    columnGap: 10
  },
  selectorButton: {
    color: '#737373',
    flex: '0 0 20em',
    justifyContent: 'flex-start',
    textTransform: 'none'
  },
  textField: {
    '&&': {
      marginBottom: 10
    }
  },
  toggleContainer: {
    columnGap: 10,
    display: 'flex'
  }
})

class ToolsPanelSelect extends React.Component {
  constructor (props) {
    super(props)
    const { title } = props
    this.pure = {}
    this.pure.title = title
    this.pure.headerIcon = <HeaderIcon />

    this.pure.upgradeText = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.text', 'Upgrade to Pozi Enterprise')
    this.pure.upgradeURL = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.url', '')
    this.pure.upgradeURLLabel = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.urlLabel', 'Learn More')
    this.pure.upgradeMarkup = <Upgrade text={this.pure.upgradeText} url={this.pure.upgradeURL} urlLabel={this.pure.upgradeURLLabel} />
  }

  addEvents () {
    PoziDrawer().updateMDL()
    PoziDrawerTabToolsBuffer().init()
    PoziSelect().init()
    PoziPropertyLookup()
      .wireup()
      .then(function (result) {
        console.log(result)
      })
      .catch(function (error) {
        console.log(error) // Probably just not configured for the site.
      })
  }

  componentDidMount () {
    const { expanded } = this.props
    if (expanded) {
      this.addEvents()
    }
  }

  componentDidUpdate (prevProps) {
    const { expanded } = this.props
    if (expanded !== prevProps.expanded && expanded) {
      this.addEvents()
    }
  }

  render () {
    const { classes, polygonSelectEnabled, bufferSelectEnabled, selectGroupEnabled, expanded, toggleExpansionPanel } = this.props

    let markup = null
    let licensed = true

    if (!selectGroupEnabled) {
      console.log('Expansion panel specifically disabled.')
      markup = this.pure.upgradeMarkup
      licensed = false
    } else if (!polygonSelectEnabled && !bufferSelectEnabled) {
      console.log('No controls enabled, so dont show this expansion panel.')
      markup = this.pure.upgradeMarkup
      licensed = false
    } else if (expanded) {
      markup = (
        <div className={classes.root}>
          <div className={classes.rowGroup}>
            <Button id="lineSelectTool" className={classes.selectorButton} color="default" variant="outlined">
              <img className={classes.buttonIcon} src={lineSelectImg} alt="Select by line" />Select by line
            </Button>
          </div>
          <div className={classes.rowGroup}>
            <Button id="regionSelectTool" className={classes.selectorButton} color="default" variant="outlined">
              <img className={classes.buttonIcon} src={regionSelectImg} alt="Select by region" />Select by region
            </Button>
          </div>
          <div className={classes.rowGroup}>
            <Button id="bufferSelectTool" className={classes.selectorButton} color="default" variant="outlined">
              <img className={classes.buttonIcon} src={selectBufferImg} alt="Buffer select" />Select by buffer
            </Button>
          </div>
          <div id="bufferSelectToolControls" className={classes.hiddenElement}>
            <div className={classes.columnGroup}>
              <div id="bufferSelectToolInfo" className={classes.rowGroup}>
                Click a location on the map, then come back here to set buffer selection.
              </div>
              <FormControl id="bufferSelectToolOptions" className={classes.toggleContainer} size="small">
                <div className={classes.rowGroup}>
                  <TextField
                    className={classes.textField}
                    id="bufferSelectToolMetres"
                    label="Distance (m)"
                    type="number"
                  />
                </div>
                <div className={classes.rowGroup}>
                  <Button id="bufferSelectToolGo" className={classes.selectorButton} color="default" variant="outlined">
                    Select
                  </Button>
                </div>
              </FormControl>
            </div>
          </div>
          <CoordinateSelectTool />
          <div className={classes.rowGroup}>
            <Button id="propertyLookupTool" className={classes.selectorButton} color="default" variant="outlined">
              <img className={classes.buttonIcon} src={selectPropertyFromCsvImg} alt="Property lookup" />Select by property PFI list (CSV)
            </Button>
          </div>
          <div id="propertyLookupToolInfo" className={classes.hiddenElement}>
            <div className={classes.columnGroup}>
              <div className={classes.rowGroup}>
                Upload a CSV file that contains a column of property pfi values. The column must have the heading `PROP_PFI` (uppercase).
              </div>
              <div className={classes.rowGroup}>
                <input id="propertyLookupToolCsv" className={classes.hiddenElement} accept="text/csv" type="file" />
              </div>
              <div className={classes.rowGroup}>
                <Button id="propertyLookupToolGo" className={classes.selectorButton} color="default" variant="outlined">
                  Select properties
                </Button>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <AccordionWrapper
        licensed={licensed}
        expanded={expanded}
        onChange={toggleExpansionPanel}
        headerIcon={this.pure.headerIcon}
        title={this.pure.title}
        bExcludeExpandIcon={false}
      >
        {markup}
      </AccordionWrapper>
    )
  }
}

ToolsPanelSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  polygonSelectEnabled: PropTypes.bool.isRequired,
  bufferSelectEnabled: PropTypes.bool.isRequired,
  selectGroupEnabled: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  toggleExpansionPanel: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  const tools = state.config?.layout?.drawer?.tabs?.tools
  const polygonSelectEnabled = tools?.polygonselect?.visible ?? true
  const bufferSelectEnabled = tools?.bufferselect?.visible ?? true
  const selectGroupEnabled = tools?.selectgroup?.visible ?? true
  const title = tools?.selectgroup?.title ?? 'Select'
  const expanded = tools?.selectgroup?.expanded ?? false
  return {
    polygonSelectEnabled,
    bufferSelectEnabled,
    selectGroupEnabled,
    title,
    expanded
  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps
    )(ToolsPanelSelect)
  )
)
